import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Divider,
  Button,
  Switch,
  HStack,
  Text
} from "@chakra-ui/react";
import { CameraSearchSelect } from "../common/SearchSelects";

const FilterDrawer = ({ 
  isOpen, 
  onClose, 
  filters, 
  handleFilterChange, 
  cameras, 
  algorithms, 
  applyAdvancedFilters, 
  resetFilters 
}) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px">Filtrar Infrações</DrawerHeader>

        <DrawerBody>
          <Box py={4}>
            <FormControl mb={4}>
              <FormLabel>Placa</FormLabel>
              <Input
                name="plate"
                placeholder="AAA0000"
                value={filters.plate}
                onChange={handleFilterChange}
              />
              <HStack mt={2} spacing={2}>
                <Switch
                  name="plateContains"
                  isChecked={filters.plateContains || false}
                  onChange={(e) => handleFilterChange({
                    target: { name: 'plateContains', value: e.target.checked }
                  })}
                />
                <Text fontSize="sm" color="gray.600">
                  Buscar placas que <strong>contenham</strong> o texto
                </Text>
              </HStack>
              <Text fontSize="xs" color="gray.500" mt={1}>
                {filters.plateContains 
                  ? "Ex: 'AAA' encontrará AAA0000, AAA0001, AAA1958..." 
                  : "Ex: 'AAA0000' encontrará apenas AAA0000 exato"
                }
              </Text>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Câmera</FormLabel>
              <CameraSearchSelect
                cameras={cameras}
                value={filters.cameraId}
                onChange={handleFilterChange}
                placeholder="Buscar câmera por nome..."
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Algoritmo</FormLabel>
              <Select
                name="algorithmId"
                placeholder="Selecione um algoritmo"
                value={filters.algorithmId}
                onChange={handleFilterChange}
              >
                {algorithms.map(algorithm => (
                  <option key={algorithm.id} value={algorithm.id}>{algorithm.name}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Status</FormLabel>
              <Select
                name="status"
                placeholder="Todos os status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="pending">Pendentes</option>
                <option value="confirmed">Confirmadas</option>
                <option value="rejected">Rejeitadas</option>
              </Select>
            </FormControl>

            <Divider my={4} />

            <FormControl mb={4}>
              <FormLabel>Data Inicial</FormLabel>
              <HStack>
                <Input
                  type="date"
                  name="startDate"
                  value={filters.startDate}
                  onChange={handleFilterChange}
                  flex="1"
                />
                <Input
                  type="time"
                  name="startTime"
                  value={filters.startTime || ""}
                  onChange={handleFilterChange}
                  maxW="140px"
                />
              </HStack>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Data Final</FormLabel>
              <HStack>
                <Input
                  type="date"
                  name="endDate"
                  value={filters.endDate}
                  onChange={handleFilterChange}
                  flex="1"
                />
                <Input
                  type="time"
                  name="endTime"
                  value={filters.endTime || ""}
                  onChange={handleFilterChange}
                  maxW="140px"
                />
              </HStack>
            </FormControl>

            <Button
              mt={4}
              colorScheme="teal"
              onClick={applyAdvancedFilters}
              width="full"
            >
              Filtrar
            </Button>

            <Button
              mt={4}
              variant="outline"
              onClick={resetFilters}
              width="full"
            >
              Limpar Filtros
            </Button>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default FilterDrawer;